import React, { useEffect, useReducer, useState } from 'react';
import {
  ExceptionContainer,
  ExceptionHeader,
  ExceptionHeaderTitle,
  ExceptionHeaderArea
} from './styles';
import Copyright from '../../components/Copyright';
import { useHistory, useLocation } from 'react-router-dom';
import { ExceptionContext } from '../../store';
import exceptionReducer from '../../store/Exception';
import INITIAL_STATE_EXCEPTION from '../../store/Exception/state';
import { exceptionSteps } from '../../helpers/enum';
import HomePage from './Home';
import ExceptionListPage from './ExceptionList';
import { P, H4, H5 } from '../../components/Typography/styles';
import colors from '../../assets/styles/colors';
import { default as ExceptionTypes } from "../../store/Exception/types";
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import Loader from '../../components/Loader';

const ExceptionPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [exception, setException] = useReducer(exceptionReducer, INITIAL_STATE_EXCEPTION);
  const [activeStep, setActiveStep] = useState(exceptionSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);

  async function initializaStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      await setException({
        type: ExceptionTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      await setException({
        type: ExceptionTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      setIsLoading(false);
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }
    
    initializaStateComponent()
  }, [])

  return (
    <ExceptionContainer id="exception-page" align={activeStep === exceptionSteps.DEFAULT}>
      {isLoading ? <Loader /> : (
        <>
          <ExceptionHeader>
            <ExceptionHeaderTitle>Clientes</ExceptionHeaderTitle>
            <ExceptionHeaderArea>
              <H4 color={colors.textPrimary}>Excepciones</H4>
              <P bold color={colors.textPrimary}>
                {exception.solicitation?.cliente.nombres} {exception.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {exception.solicitation?.cliente.identificacion}
              </P>
            </ExceptionHeaderArea>
            {activeStep === exceptionSteps.EXCEPTIONS ? <H5 color={colors.textPrimary}>Selecciona un máximo de cinco (5) exepciones para la solicitud de crédito</H5> : '' }
          </ExceptionHeader>
          <ExceptionContext.Provider value={{ exception, setException }}>
            {activeStep === exceptionSteps.DEFAULT && (
              <HomePage setActiveStep={setActiveStep} />
            )}

            {activeStep === exceptionSteps.EXCEPTIONS && (
              <ExceptionListPage setActiveStep={setActiveStep} />
            )}
          </ExceptionContext.Provider>
          <Copyright />
        </>
      )}
    </ExceptionContainer>
  )
}

export default ExceptionPage;
